import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RailETicketItem } from '@sabstravtech/obtservices/base';
import { EnterpriseBasketService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';
import { BaseModalComponent } from '../base-modal.component';

@Component({
  selector: 'app-rail-eticket-download-modal',
  templateUrl: './rail-eticket-download-modal.component.html',
  styleUrls: ['./rail-eticket-download-modal.component.scss'],
  standalone: false
})
export class RailEticketDownloadModalComponent extends BaseModalComponent {
  eTicketItems: RailETicketItem[] = [];
  isTrainline = false;
  walletImageBaseUrl = 'https://images.sabscorp.com/images/enterprise/lightUK/assets/png/';
  downloadingItems = new Set<string>();
  downloadError = '';

  constructor(
    public activeModal: NgbActiveModal,
    private basketService: EnterpriseBasketService
  ) {
    super(activeModal);
  }

  private extractOriginalUrl(link: string): string {
    if (link?.includes('eticket-proxy?url=')) {
      const urlParam = link.split('eticket-proxy?url=')[1];
      return decodeURIComponent(urlParam);
    }
    return link;
  }

  openETicketLink(link: string): void {
    if (link) {
      window.open(link, '_blank');
    }
  }

  downloadETicket(link: string, filename: string): void {
    if (!link || this.downloadingItems.has(filename)) {
      return;
    }
    this.downloadError = '';
    this.downloadingItems.add(filename);
    const originalUrl = this.extractOriginalUrl(link);
    this.subscribe(
      this.basketService.downloadETicket(originalUrl),
      (result) => {
        const content = result?.content;
        const contentType = result?.contentType;
        const byteCharacters = atob(content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
        this.downloadingItems.delete(filename);
      },
      () => {
        this.downloadingItems.delete(filename);
        this.downloadError = 'Failed to download eTicket. Please try again.';
      }
    );
  }

  closeModal(): void {
    this.activeModal.close(true);
  }
}

LightningModalTypes.RailEticketDownloadModalComponent.component = RailEticketDownloadModalComponent;
